import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import PrintLabelsView from "../printing/print-labels";
import PrintCatalogueView from "../printing/print-catalogue";
import PrintHubView from "./print-hub";
import PrintPackingListView from "./print-packing-list";
import useAccessLevels from "../../../../hooks/use-access-levels";
import PrintBrochureView from "./print-brochure";


const PrintingView = () => {
    const operatorAccessLevels = useAccessLevels();
    const location = useLocation();
    const history = useHistory();


    /**
     * Listens for the changes in the url and which each change
     * if the url is the same as /products, changes it immediately to the /products/list
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.printing.base, exact: true})) {
            if (operatorAccessLevels.packages.bizPrint.printHub) {
                history.replace(routes.printing.printHub);
            } else if (operatorAccessLevels.packages.bizPrint.printLabels) {
                history.replace(routes.printing.printLabels);
            } else if (operatorAccessLevels.packages.bizPrint.printCatalogue) {
                history.replace(routes.printing.printCatalogue);
            } else if (operatorAccessLevels.packages.bizPrint.printPackingList) {
                history.replace(routes.printing.printPackingList);
            } else {
                history.replace(routes.printing.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.bizPrint.printCatalogue, operatorAccessLevels.packages.bizPrint.printHub, operatorAccessLevels.packages.bizPrint.printLabels, operatorAccessLevels.packages.bizPrint.printPackingList])

    return (
        <Switch>
            <Route path={routes.printing.base} exact/>
            {
                operatorAccessLevels.packages.bizPrint.printHub &&
                <Route path={routes.printing.printHub} exact>
                    <PrintHubView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizPrint.printLabels &&
                <Route path={routes.printing.printLabels} exact>
                    <PrintLabelsView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizPrint.printCatalogue &&
                <Route path={routes.printing.printCatalogue} exact>
                    <PrintCatalogueView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizPrint.printBrochure &&
                <Route path={routes.printing.printBrochure} exact>
                    <PrintBrochureView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizPrint.printPackingList &&
                <Route path={routes.printing.printPackingList} exact>
                    <PrintPackingListView/>
                </Route>
            }
            <Redirect to={routes.printing.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default PrintingView;
